import(/* webpackMode: "eager" */ "/var/www/webduan/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/webduan/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Be_Vietnam_Pro\",\"arguments\":[{\"subsets\":[\"latin\",\"vietnamese\"],\"weight\":[\"400\",\"500\",\"600\",\"700\",\"800\"],\"variable\":\"--font-be-vietnam-pro\",\"display\":\"swap\"}],\"variableName\":\"beVietnamPro\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/AgentationBridge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/chat/ChatWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/GlobalSideBanners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/ScrollReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/SiteVisitTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/webduan/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/var/www/webduan/src/contexts/CartContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteConfigProvider"] */ "/var/www/webduan/src/contexts/SiteConfigContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/webduan/src/styles/index.css");
